import moment from 'moment';

import { DISPATCHER_CONSTANTS } from './dispatcher_constants';

const DEFAULT_OFFSET = 0;

const TIMES = {
  from: DISPATCHER_CONSTANTS.DEFAULT_TIMES_FROM,
  till: DISPATCHER_CONSTANTS.DEFAULT_TIMES_TILL,
};

function normalize(value: Date | string, tz: string): number {
  const adjusted = moment.tz(value, tz);
  return (
    (adjusted.hour() * 60 * 60 + adjusted.minute() * 60 - TIMES.from * 60 * 60) / ((TIMES.till - TIMES.from) * 60 * 60)
  );
}

type OrderPositionInput = {
  scheduled: Date | string;
  estimated_duration?: number | null;
  moving?: boolean;
  moving_operation?: { estimated_duration?: number | null } | null;
  sla_window_size: number;
  dispatch_offset: number;
  region: { tz: string };
};

export function positionForOrder(
  order: OrderPositionInput,
  options: { offset?: number; padded?: boolean } = {},
): { top: number; bottom: number } {
  const { tz } = order.region;
  let travelAndJobDuration = order.estimated_duration;
  if (order.moving) {
    travelAndJobDuration = (travelAndJobDuration ?? 0) + (order.moving_operation?.estimated_duration ?? 0);
  }
  const duration = moment.duration(
    travelAndJobDuration || DISPATCHER_CONSTANTS.DEFAULT_ESTIMATED_DURATION,
    DISPATCHER_CONSTANTS.ESTIMATED_DURATION_UNITS,
  );
  const offset = moment.duration(options.offset ?? DEFAULT_OFFSET, DISPATCHER_CONSTANTS.DISPATCHER_OFFSET_UNITS);
  const from = moment(order.scheduled).valueOf() + offset.asMilliseconds();
  let till = moment(order.scheduled).valueOf() + offset.asMilliseconds() + duration.asMilliseconds();

  if (options.padded) {
    till += moment
      .duration(order.sla_window_size * DISPATCHER_CONSTANTS.DEFAULT_WINDOW_SLOT_DURATION, 'seconds')
      .asMilliseconds();
  }

  return {
    top: normalize(new Date(from), tz),
    bottom: normalize(new Date(till), tz),
  };
}

export function positionForTime(time: Date | string, tz: string): number {
  return normalize(time, tz);
}

export function toPercentageStyle(percent: number): string {
  return `${percent * 100}%`;
}
